import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductSkuElement extends HTMLElement {
  connectedCallback() {
    const sectionRoot = this.closest('.shopify-section, dialog');
    sectionRoot?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantChange);
  }

  disconnectedCallback() {
    const sectionRoot = this.closest('.shopify-section, dialog');
    sectionRoot?.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantChange);
  }

  /**
   * Refresh SKU info whenever the variant changes.
   * @param {VariantUpdateEvent} event
   */
  #handleVariantChange = (event) => {
    const { data } = event.detail;
    const target = event.target;

    if (!data.newProduct && target instanceof HTMLElement && target.dataset.productId !== this.dataset.productId) {
      return;
    }

    if (data.newProduct) {
      this.dataset.productId = data.newProduct.id;
    }

    const incomingSku = data.html.querySelector('product-sku');
    if (!incomingSku) return;

    morph(this, incomingSku, { childrenOnly: true });
  };
}

if (!customElements.get('product-sku')) {
  customElements.define('product-sku', ProductSkuElement);
}